import {
FETCH_PAIDOVERTIMES_SUCCESS,
FETCH_PAIDOVERTIMES_MONTH_SUCCESS,
ADD_PAIDOVERTIME,
SET_PAIDOVERTIME_ID
} from "actions/types";

import { paidOvertimes, paidOvertimesMonth, paidOvertimeAdd } from "../api";
import { dataFailure, dataSuccess } from "./general";

export const setPaidOvertimeId = (id) => {
  return {
    type: SET_PAIDOVERTIME_ID,
    payload: id,
  };
};

const fetchPaidOvertimesSuccess = (values) => {
  return {
    type: FETCH_PAIDOVERTIMES_SUCCESS,
    payload: values,
  };
};

export const fetchPaidOvertimes = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(paidOvertimes(values));
      await dispatch(fetchPaidOvertimesSuccess(JSONData));
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const fetchPaidOvertimesMonthSuccess = (values) => {
  return {
    type: FETCH_PAIDOVERTIMES_MONTH_SUCCESS,
    payload: values,
  };
};

export const fetchPaidOvertimesMonth = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(paidOvertimesMonth(values));
      await dispatch(fetchPaidOvertimesMonthSuccess(JSONData));
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};

const savePaidOvertimeData = (values) => {
  return {
    type: ADD_PAIDOVERTIME,
    payload: values,
  };
};

export const savePaidOvertime = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(paidOvertimeAdd(values));
      await dispatch(savePaidOvertimeData(values));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err.message));
    }
  };
};
